import * as React from 'react';
import type {
  RevertRedirectedProductsPayload,
} from 'contracts/redirected-products';
import { api } from 'services/api';

export const useRevertRedirectedProducts = () => {
  const revertRedirectedProducts = React.useCallback(async (payload: RevertRedirectedProductsPayload) => {
    await api.post('/inventory/redirected-products/revert', payload);
  }, []);

  return {
    revertRedirectedProducts,
  };
};